import React, { useState, useEffect } from 'react';
import { Logger } from 'stores/Classes';
import { Form, Input, Row, Col, Select } from 'antd';

import {
  ShopStore,
  CurrentUserStore,
  InspectionsStore,
  UserStore,
} from 'stores';

const { Option } = Select;

const CreatedBy = ({ form }) => {
  const [users, setUsers] = useState([]);
  useEffect(() => {
    const initialize = async () => {
      await loadData(ShopStore.currentShop.id);
    };

    initialize();
  }, []);

  const loadData = async (shopId) => {
    try {
      const users = await UserStore.fetchShopUsers(shopId);

      setUsers(users);
    } catch (e) {
      Logger.log(e);
    }
  };

  const usersOptions = users.map((user) => ({
    label: `${user.firstName} ${user.lastName}`,
    value: user.userId,
  }));

  return (
    <Col span={12}>
      <Form.Item
        label="Created By"
        required
        name="createdBy"
        rules={[{ required: true, message: 'Created By is required' }]}
        style={{ marginBottom: 10 }}
      >
        <Select
          showSearch
          placeholder="Select a User"
          options={usersOptions}
          optionFilterProp="label"
        />
      </Form.Item>
    </Col>
  );
};

export default CreatedBy;
